import script from "./CompareChartView.vue?vue&type=script&setup=true&lang=js"
export * from "./CompareChartView.vue?vue&type=script&setup=true&lang=js"

import "./CompareChartView.vue?vue&type=style&index=0&id=63691510&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-63691510"]])

export default __exports__